<footer class="footer">
  <div class="footer-content">
    <div class="footer-logos-row">
      @for (ente of enti; track ente.nome.valore) {
        <div class="footer-logo-block">
          <a [href]="ente.website.valore" target="_blank" rel="noopener noreferrer"
            [attr.aria-label]="(ente.nome | contenutoValore) + ' (apre in una nuova finestra)'">
            <img [src]="ente.logo | contenutoRisorsa" [alt]="ente.nome | contenutoValore" class="footer-logo" />
          </a>
          <address class="footer-contact">
            <span class="footer-address">{{ente.indirizzo | contenutoValore}}</span>
            <span class="footer-email">email: <a
                [href]="'mailto:' + ente.email.valore">{{ente.email | contenutoValore}}</a></span>
          </address>
        </div>
      }
    </div>

    <div class="footer-legal-links">
      @for (link of links; track link.label) {
        @if (link.external) {
          <a [href]="link.path" [target]="link.path === '#' ? null : '_blank'"
            [rel]="link.path === '#' ? null : 'noopener noreferrer'">{{ link.label }}</a>
        } @else {
          <a [routerLink]="link.path">{{ link.label }}</a>
        }
        @if (!$last) { <span class="footer-legal-links-sep" aria-hidden="true">|</span> }
      }
    </div>
  </div>
</footer>